import React from 'react'
import { Stack, Typography } from '@mui/material'
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined'
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'

export type NoticeSeverity = 'warning' | 'error' | 'info'

export type Notice = {
    text: string
    severity: NoticeSeverity
}

type Props = {
    notices: Notice[]
}

function Icon({ severity }: { severity: NoticeSeverity }) {
    const sx = { fontSize: 16, mt: 0.15, flexShrink: 0 }
    if (severity === 'error') return <ErrorOutlineOutlinedIcon color="error" sx={sx} />
    if (severity === 'warning') return <WarningAmberOutlinedIcon color="warning" sx={sx} />
    return <InfoOutlinedIcon color="info" sx={sx} />
}

export default function NoticeStrip({ notices }: Props) {
    if (!notices.length) return null
    return (
        <Stack spacing={0.75} sx={{ mt: 1.25 }}>
            {notices.map((notice) => (
                <Stack key={notice.text} direction="row" spacing={0.75} alignItems="flex-start">
                    <Icon severity={notice.severity} />
                    <Typography variant="caption" color="text.primary" sx={{ lineHeight: 1.45 }}>
                        {notice.text}
                    </Typography>
                </Stack>
            ))}
        </Stack>
    )
}
